import axios from 'axios';

export const isCancelError = error => axios.isCancel(error);
export const isServerError = error =>
  axios.isAxiosError(error) && error.response?.status >= 500;
export const isAuthError = error =>
  axios.isAxiosError(error) && error.response?.status === 403;
export const isNetworkError = error =>
  axios.isAxiosError(error) && error.response?.status === 0;
export const isNotFoundError = error =>
  axios.isAxiosError(error) && error.response?.status === 404;
